//application_url
export const APPLICATION_URL = "/application"
export const STATES_URL = "/states"
export const COUNTRY_URL = "/countrys"
export const DEGREE_URL = "/degrees"
export const REGISTER_URL= "/registers"